import React from "react";
import Modal from "./Modal";
import { Copy, Check, Mail } from "lucide-react";

interface InvitationUrlModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  invitationUrl: string | null;
  isCopied: boolean;
  onCopyInvitationUrl: () => void;
}

const InvitationUrlModal: React.FC<InvitationUrlModalProps> = ({
  isOpen,
  setIsOpen,
  invitationUrl,
  isCopied,
  onCopyInvitationUrl,
}) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="sm:flex sm:items-start">
        <div className="mt-3 sm:mt-0 text-left w-full">
          <h3 className="text-lg font-semibold leading-6 text-gray-900 mb-4">
            Invitation sent!
          </h3>

          <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-md flex items-start gap-3">
            <Mail className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-green-800">
              An invitation email has been sent. They will need to click the link in the email to accept the invitation and join the organisation.
            </p>
          </div>

          <div className="mb-4">
            <p className="text-sm text-gray-500 mb-3">
              You can also copy the invitation link below to share it directly:
            </p>

            <div className="bg-gray-50 border border-gray-300 rounded-md p-3 mb-3">
              <p className="text-sm text-gray-800 break-all font-mono">
                {invitationUrl}
              </p>
            </div>

            <button
              type="button"
              onClick={onCopyInvitationUrl}
              className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors border border-gray-300"
            >
              {isCopied ? (
                <>
                  <Check className="w-4 h-4" />
                  Copied!
                </>
              ) : (
                <>
                  <Copy className="w-4 h-4" />
                  Copy invitation URL
                </>
              )}
            </button>
          </div>

          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="w-full sm:w-auto inline-flex justify-center rounded-md bg-[#1d365d] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[#162a4a]"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InvitationUrlModal;
